
export class Reading {

    readingId: string;
    facilityId: string;
    groupId: string;
    groupName: string;
    categoryId: string;
    categoryName: string;
    patientId: string;
    patientName: string;
    createdByUserId: string;
    createdByUserName: string;
    readingPartId: string;
    measurementTypeId: string;
    measurementType: string;
    measurementTypePart: string;
    value: number;
    isExtreme: boolean;
    thresholdType: string;
    thresholdValue: number;
    unit: string;
    readingOn: Date;
    isBreach: boolean;
    isDeleted: boolean;
    readingNotes: any;
    qualifiers: string;
    deviceName: string;
    deviceIp: string;
    measurementTypeDescription: string;
    isObservationSynced: boolean;
}

export class ReadingNote {
    readingNoteId: string;
    readingId: string;
    readingNoteBy: string;
    readingNoteOn: Date;
    readingNote: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/reading.ts